<section>
    <div class="container">
        <div class="row" class="font-weight-bold text-primary title-style">
            Client Details
        </div>        
    </div>
</section>